import { z } from 'zod';
import { genderSchema } from '../const/genderSchema';
import { productImportErrorKindSchema } from '../const/productImportErrorKindSchema';

export const importProblemKindSchema = productImportErrorKindSchema;
export const importMappingTargetSchema = z.enum(['CATEGORY', 'BRAND', 'SIZE']);
export const importMappingReasonSchema = z.enum(['SYSTEM_NOT_FOUND', 'RULE_UNLINKED', 'CATEGORY_NAME_MISSING']);

export const importProblemSchema = z
    .object({
        kind: importProblemKindSchema,
        blocked: z.boolean().default(false),

        message: z.string().min(1).optional(),
        code: z.string().optional(),
        path: z.array(z.string()).default([]),

        target: importMappingTargetSchema.nullable().optional(),
        reason: importMappingReasonSchema.nullable().optional(),

        categoryName: z.string().nullable().optional(),
        brandName: z.string().nullable().optional(),
        sizeKey: z.string().nullable().optional(),
        gender: genderSchema.nullable().optional(),
    })
    .strict();
